<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>

                            <p v-if="legalInformation">{{ legalInformation.contactLawyersNoCollectiveAgreement.legalAdvice }}</p>

                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                        name="exemption"
                                        method="post"
                                        enctype="multipart/form-data"
                                        novalidate="novalidate"
                                        class="needs-validation"
                                >
                                    <!-- Email -->
                                    <label class="required-field-asterisks required"
                                           for="email"
                                    >Adresse email</label>
                                    <input type="email"
                                           id="email"
                                           class="form-control form-control-lg"
                                           placeholder="Email"
                                           :class="{ 'is-invalid': $v.formData.email.$error }"
                                           @input="delayTouch($v.formData.email)"
                                           v-model="formData.email"
                                    >
                                    <FormError error="Format de l'email incorrect"
                                               v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                                    ></FormError>
                                    <FormError error="Veuillez renseigner l’email"
                                               v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                                    ></FormError>
                                    <!-- Email -->

                                    <!-- Phone Number -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks required"
                                               for="phone">Numéro de téléphone</label>
                                        <div class="input-group" >
                                            <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="fas fa-phone"></i>
                                                    </span>
                                            </div>
                                            <masked-input
                                                    type="tel"
                                                    mask="\+\33 1 11 11 11 11"
                                                    id="phone"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.formData.phoneNumber.$error }"
                                                    @input="maskedDelayTouch($v.formData.phoneNumber)"
                                                    v-model="formData.phoneNumber"
                                            />
                                        </div>
                                        <FormError error="Le numéro de téléphone doit contenir 11 chiffres"
                                                   v-if="!$v.formData.phoneNumber.phoneLength && $v.formData.phoneNumber.$dirty"
                                        ></FormError>
                                    </div>
                                    <!-- Phone Number -->

                                    <!-- Collective Agreement -->
                                    <label class="required-field-asterisks required"
                                           for="collectiveAgreement"
                                    >Veuillez préciser votre type d'activité</label>
                                    <input
                                        type="text"
                                        id="collectiveAgreement"
                                        class="form-control form-control-lg"
                                        :class="{ 'is-invalid': $v.formData.collectiveAgreement.$error }"
                                        @input="delayTouch($v.formData.collectiveAgreement)"
                                        v-model="formData.collectiveAgreement"
                                    >
                                    <FormError error="Veuillez renseigner votre type d'activité "
                                               v-if="$v.formData.collectiveAgreement.$error"
                                    ></FormError>
                                    <p
                                        v-if="legalInformation"
                                        v-html="legalInformation.contactUsCollectiveAgreementIdLegalAdviceText.legalAdvice"
                                        class="input-legend"></p>
                                    <!-- Collective Agreement -->

                                    <!-- Message -->
                                    <label for="reject-reason"
                                           class="required-field-asterisks"
                                    >Message</label>
                                    <textarea id="reject-reason"
                                              class="form-control form-control-lg"
                                              :class="{ 'is-invalid': $v.formData.message.$error }"
                                              @input="delayTouch($v.formData.message)"
                                              v-model="formData.message"
                                    ></textarea>
                                    <FormError error="Le numéro de téléphone doit contenir 11 chiffres"
                                               v-if="$v.formData.message.$error"
                                    ></FormError>
                                    <!-- Message -->

                                    <!-- Is valid input info -->
                                    <div class="form-group mt-3">
                                        <template v-if="legalInformation">
                                            <p class="mb-0">
                                                <template
                                                    v-for="(legalAdvice) in legalInformation.contactLawyersNoCollectiveAgreementGroupInsuranceContract.legalAdvice"
                                                   >
                                                    {{ legalAdvice }}
                                                </template>
                                            </p>
                                            <p class="mt-2 font-weight-bold">
                                                <template
                                                    v-for="(legalAdvice) in legalInformation.contactLawyersNoCollectiveAgreementAllInformationCorrect.legalAdvice"
                                                >
                                                    {{ legalAdvice }}
                                                </template>
                                            </p>
                                        </template>

                                        <div class="icheck-primary d-inline">
                                            <input type="checkbox"
                                                   id="isValidInputInfo"
                                                   v-model="isValidInputInfo"
                                            >
                                            <label
                                                for="isValidInputInfo"
                                                @click.prevent="handleChangeIsValidInputInfo"
                                                class="required-field-asterisks required"
                                            >
                                                Je valide que toutes les informations sont conformes
                                            </label>
                                        </div>
                                    </div>
                                    <!-- Is valid input info -->
                                </form>
                            </div>
                        </div>

                        <div class="input-group col-md-10 mx-sm-auto my-md-4">
                            <div class="mx-sm-auto">
                                <button class="btn btn-lg mr-4 btn-link btn__primary"
                                        :disabled="isLoading"
                                        @click.prevent="toPreviousStep"
                                >
                                    <span>Revenir à l'étape précédente</span>
                                </button>

                                <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                        :disabled="$v.$invalid || isLoading || !isValidInputInfo"
                                        @click.prevent="send"
                                >
                                    <span>Confirmer ma demande</span>
                                    <ButtonSpinner :isLoading="isLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import MaskedInput from 'vue-masked-input';
    import DueFirstStepManager from '../../../service/manager/due/firstStepManager';
    import FormError from '../../../components/FormError';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import Header from '../../../components/Header';
    import { email, required } from 'vuelidate/lib/validators';
    import { phoneNumberConstraint } from '../../../utils/validation';
    import { mapActions, mapGetters } from 'vuex';
    import { createContactLawyersResource } from '../../../service/api/dues.api';

    export default {
        mixins: [ValidationDelayTouch, DueStepsNavigation],
        data() {
            return {
                formData: {
                    email: '',
                    phoneNumber: '',
                    message: '',
                    codeNaf: '',
                    collectiveAgreement: ''
                },
                isLoading: false,
                isValidInputInfo: false
            };
        },
        computed: {
            ...mapGetters({
                legalInformation: 'legalInformation',
                due: 'due'
            }),
        },
        async mounted() {
            await this.fetchDueLegalInformation();
            await this.processDueCodeNaf();
        },
        methods: {
            ...mapActions({
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async send() {
                this.isLoading = true;
                try {
                    await createContactLawyersResource(
                        {
                            ...DueFirstStepManager.createContactLawyersRequest(this.formData),
                            reason: 'no_collective_agreement'
                        }
                    );

                    this.isLoading = false;
                    await this.$router.push({
                        name: 'success',
                        params: { messageShortCode: 'contact_lawyers_email' }
                    });
                } catch ({ response }) {
                    this.isLoading = false;
                }
            },
            async toPreviousStep() {
                await this.$router.push(this.buildRoute('due-first-step'));
            },
            async processDueCodeNaf() {
                if (this.due && this.due.codeNaf) {
                    this.formData.codeNaf = this.due.codeNaf;
                }
            },
            handleChangeIsValidInputInfo() {
                this.isValidInputInfo = !this.isValidInputInfo;
            }
        },
        validations: {
            formData: {
                email: {
                    required,
                    email
                },
                phoneNumber: {
                    phoneLength: phoneNumberConstraint,
                    required
                },
                message: {
                    required
                },
                collectiveAgreement: {
                    required
                }
            }
        },
        components: {
            Sidebar,
            Footer,
            MaskedInput,
            FormError,
            ButtonSpinner,
            Header
        }
    }
</script>
